import Button from '@mui/material/Button'
import { ComponentProps, useCallback, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { useUser } from '@/modules/auth/hooks/useUser.js'
import { LogoutFlowStates } from '@/system/form/states.ts'

import messages from './messages.ts'

export const LogoutButton = (props: ComponentProps<typeof Button>) => {
  const { logout } = useUser()
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  useEffect(() => {
    const handleMessage = async (e: MessageEvent) => {
      if (e.data === LogoutFlowStates.LogoutDone) {
        await logout()
        navigate('/')
      }
      // TODO: Handle error case
    }
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [logout, navigate])
  const handleLoginClick = useCallback(() => {
    window.open(`/logout.html`, 'logoutPopup', 'popup')
  }, [])
  return (
    <Button onClick={handleLoginClick} color="secondary" {...props}>
      {formatMessage(messages.logout)}
    </Button>
  )
}
